const buildNavItem = (args) => {
    const {href, text, clickHandler, children, className = "", scrollTo} = args;
    let navItem = { href, text, className, clickHandler, scrollTo };

    if (children && children.length) {
        navItem.className += ' has-submenu';
        navItem.subMenu = {
            className: 'sub-menu',
            items: children.map(child => buildNavItem({
                href: child.href,
                text: child.text,
                children: child.children,
                clickHandler: child.clickHandler,
                className: child.className
            }))
        }
    }

    return navItem;
};

export default buildNavItem;


// WEBPACK FOOTER //
// ./src/utils/NavItemBuilder.js